import React, { useState, useEffect } from "react";
import LedgerAutoForm from "../forms/LedgerAutoForm";

function AddGlModal({ onClose, onSave }) {
  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: "#00000080" }}>
      <div className="modal-dialog modal-xl modal-dialog-scrollable">
        <div className="modal-content">

          <div className="modal-header bg-light">
            <h5 className="modal-title">Add New Ledger / Account</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body">
            <LedgerAutoForm
              asForm={false}
              onSuccess={(createdLedger) => {
                onSave(createdLedger); // 🔥 pass to TransactionForm
              }}
            />
          </div>

        </div>
      </div>
    </div>
  );
}

export default AddGlModal;
